/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  InstantSearchResultItemProduct.prototype.compileTemplate = function () {
    if (this.isShow) {
      var searchTerm = Utils.stripHtml(Globals.currentTerm);
      var data = this.data;
      var finalImgURL = this.imageUrl;
      var matchedVariant = data.variants[0];
      var productURL = this.url;

      if (data.variants.length > 1) {
        var matchedResult = data.variants.find(variant => variant.title.toLowerCase().trim() === Globals.currentTerm?.toLowerCase().trim());
        if (matchedResult) {
          matchedVariant = matchedResult;
          finalImgURL = matchedVariant.image;
          productURL = productURL.includes('?') ? productURL + '&variant=' + matchedVariant.id : productURL + '?variant=' + matchedVariant.id
        }
      }

      // Product image
      var imageHTML = '';
      if (Settings.getSettingValue('search.showSuggestionProductImage') && finalImgURL.length) {
        imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
        imageHTML = imageHTML.replace(/{{imageUrl}}/g, finalImgURL);
      }
      // Product title
      var productTitle = this.customizeProductTitle();
      productTitle = data.variants.length > 1 && matchedVariant?.title.toLowerCase() !== 'default title' ? `${productTitle} in ${matchedVariant?.title}` : productTitle;
      productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
      // SKU
      var skuHTML = '';
      if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
        skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
        skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
      }
      // Vendor
      var vendorHTML = '';
      if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
        vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
        vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
      }
      // Price
      var priceHTML = this.compileSuggestionProductPrice();
      // Open the result item in new tab when selected
      var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

      return this.getTemplate()
        .replace(/{{id}}/g, this.id+"test")
        .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
        .replace(/{{url}}/g, productURL)
        .replace(/{{newTabAttribute}}/g, newTabAttr)
        .replace(/{{itemProductImage}}/g, imageHTML)
        .replace(/{{title}}/g, productTitle)
        .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
        .replace(/{{itemProductSku}}/g, skuHTML)
        .replace(/{{itemProductVendor}}/g, vendorHTML)
        .replace(/{{itemProductPrice}}/, priceHTML)
        .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
        .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
        .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
    } else {
      return '';
    }
  }

})();